<template>
  <Modal :value="visible" @on-cancel="cancel" width="700" :footer-hide="true">
    <div class="pd-20 mg-top10">
      <myTable :columns="columns" requestUrl="school/list" :showPage="true" v-if="visible">
        <template v-slot:topic="{data}">
          <Tooltip placement="top">
            <div class="topic">{{ data.row.school_cname }}</div>
            <div slot="content" class="tooltip">
              <div>{{ data.row.school_cname }}</div>
            </div>
          </Tooltip>
        </template>
      </myTable>
      <div class="btnCtn">
        <Button @click="cancel" type="primary" class="btn">{{ $t('close') }}</Button>
      </div>
    </div>
  </Modal>
</template>

<script>
import myTable from '../../../components/myTable'

export default {
  components: {
    myTable
  },
  props: {
    visible: Boolean,
  },
  data: function () {
    return {
      columns: [
        { title: this.$t('topic'), key: 'school_cname', align: 'center', slot: 'topic' },
        { title: this.$t('last_update_time'), key: 'add_time', align: 'center' },
      ],
    }
  },
  methods: {
    ok: function () {
      this.$emit('onClose')
    },
    cancel: function () {
      this.$emit('onClose')
    },
  }
}
</script>

<style scoped>
.btn {
  font-size: 14px;
}
.btnCtn {
  margin-top: 20px;
  display: flex;
  justify-content: end;
}
.topic {
  width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tooltip {
  white-space: normal;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/school/record/newsModal.vue